import React from 'react';
import ReportCardGrid, { Report } from '../shared/ReportCardGrid';

const campaignReports: Report[] = [
  { title: 'Campaign Dispositions', description: 'The outcomes and dispositions of leads/prospects', to: '/disposition-report', image: 'https://media.istockphoto.com/id/1208395845/vector/people-planning-concept-entrepreneurship-and-calendar-schedule-planning-vector-business.jpg?s=612x612&w=0&k=20&c=DXy2mn1xa5fr_k_NbTSo0o48PeYFUPoVw9SvUHatYqI=' },
  { title: 'Lead Summary', description: 'Summary of lead generated with efforts and outcomes from respective campaigns', to: '/campaign-lead-report', image: 'https://img.freepik.com/free-vector/generating-new-leads-concept-illustration_114360-7654.jpg?size=626&ext=jpg' },
];

const CampaignLists = () => {
  return (
    <ReportCardGrid
      reports={campaignReports}
      sectionTitle="Leads"
      basePath="/reports/campaign"
    />
  );
};

export default CampaignLists;

